// BagpipeTutor/src/components/DirectFunctionTest.js
import { useEffect, useState } from "react";

function DirectFunctionTest() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("https://localhost:8888/.netlify/functions/hello", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then((data) => setData(data))
      .catch((err) => setError(err.message));
  }, []);

  return (
    <div>
      <h1>Direct Function Test</h1>
      {data ? <pre>{JSON.stringify(data, null, 2)}</pre> : <p>Loading...</p>}
      {error && <p>Error: {error}</p>}
    </div>
  );
}

export default DirectFunctionTest;